import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

const Title = styled.div`
  font-size: 12px;
  line-height: 13px;
  flex: 1;
`;

const CoachDescription = ({ children }) => <Title>{children}</Title>;

CoachDescription.propTypes = {
  children: PropTypes.shape({})
};

CoachDescription.defaultProps = {
  children: null
};

export default CoachDescription;



// WEBPACK FOOTER //
// ./src/components/CoachInfos/CoachDescription.jsx